import { useMutation } from "@tanstack/react-query";

import toast from "react-hot-toast";
import { verificationService } from "../api/services/cashExchange/verificationService";

export const useVerifyAgent = () => {
  return useMutation({
    mutationFn: (agentId: string) => verificationService.verifyAgent(agentId),
    onError: (error: { response?: { data?: { message?: string } } }) => {
      const errorMessage =
        error.response?.data?.message || "Failed to verify agent";
      toast.error(errorMessage);
    },
  });
};

export const useVerifyCustomer = () => {
  return useMutation({
    mutationFn: (playerId: string) =>
      verificationService.verifyCustomer(playerId),
    onError: (error: { response?: { data?: { message?: string } } }) => {
      const errorMessage =
        error.response?.data?.message || "Failed to verify player";
      toast.error(errorMessage);
    },
  });
};
